export const useStyles = (theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bold",
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  gridContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  listitemRoot: {
    width: "100%",
    display: "flex",
    [theme.breakpoints.down(600)]: {
      flexDirection: "column",
    },
  },
  listitemContent: {
    width: "50%",
    marginRight: 10,
    [theme.breakpoints.down(600)]: {
      width: "100%",
      marginRight: 0,
    },
  },
  tooltip: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  paper: {
    padding: 20,
  },
});
